import React, { useEffect, useRef, useState } from "react";
import BaseUrl from "../../base-api";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { handleAxiosError } from "../Utility/handleAxiosError";
import { isloading } from "../redux/reducer/LoadingReducer";
import { useDispatch } from "react-redux";
import AxiosInstance from "../Utility/AxiosInstance";
import { validateStep, getTodayMaxDate, validateExperienceDates } from "../utils/registrationValidation";
import { validateDischargePdfFile, validateExperiencePdfFile } from "../utils/dischargePdfValidation";
import { saveRegistrationStep, buildRegistrationFormData, fetchUserRegistrationData } from "../utils/registrationFormData";
import FormField from "../utils/FormField";
import {
  validateAlphabetsWithSpace,
  validateNumeric,
  validateAlphaNumeric,
  validateName,
  validateAddress,
  validateEmail,
  validateMobile,
  validatePincode
} from "../utils/inputValidations";
import EmployeeEsmFormView from "./EmployeeEsmFormView";
import DischargeDocumentField, { findSavedDischargeDoc } from "../utils/DischargeDocumentField";
import ExperienceDocumentField, { viewExperienceDocument } from "../utils/ExperienceDocumentField";

const Registration = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
const topRef = useRef(null);
const experienceFormRef = useRef(null);

const HEADER_OFFSET = 250;

const scrollToExperienceForm = () => {
  requestAnimationFrame(() => {
    const el = experienceFormRef.current;
    if (!el) return;
    const offset = window.innerWidth > 768 ? HEADER_OFFSET : 100;
    const topY = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, topY), behavior: "smooth" });
    el.focus({ preventScroll: true });
  });
}; 

const scrollToTop = () => {

  if (window.innerWidth > 768) {
  const topY = topRef.current?.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
  window.scrollTo({
    top: topY > 0 ? topY : 0,
    behavior: "smooth",
  });
}
};


  const [isExServiceman, setIsExServiceman] = useState(""); 
  const shouldLoadForm = isExServiceman === "Yes";

  const [formData, setFormData] = useState({
    pppIdEnabled: false,
    forceNumber: "",
    forceName: "",
    service: "",
    type: "",
    rank: "",
    fullName: "",
    medicalCategory: "",
    dischargeDate: "",
    dischargeBookNo: "",
    dischargePdf:null,
    unitRetired: "",
    fatherName: "",
    motherName: "",
    dob: "",
    state: "",
    district: "",
    tehsil: "",
    village: "",
    address: "",
    pinCode: "",
    email: "",
    mobile: "",
    altMobile: "",
    otp: "",
    gender: "",             
    maritalStatus: "", 
    pppId: "",
    memberId: "",
    verifiedMemberName: "",
    benchmarkDisability: "",   
    casteCategoryId: "",             
    qualificationId: "",      
    engagementId: "",         
    totalAnnualFamilyIncome: "",    
    incomeVerified: "", 
    coveredUnderSocioEconomic: "",
    ppoNo: "",
    ppoDate: "",
  });

  const [savedDischargeDoc, setSavedDischargeDoc] = useState(null);
  const [isReplacingDischargeDoc, setIsReplacingDischargeDoc] = useState(false);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [tehsils, setTehsils] = useState([]);
  const [forces, setForces] = useState([]);
  const [services, setServices] = useState([]);
  const [types, setTypes] = useState([]);
  const [ranks, setRanks] = useState([]);
  const [rankHierarchyData, setRankHierarchyData] = useState([]);
  const [medical, setMedical] = useState([]);
  const [genders, setGenders] = useState([]);
  const [maritalStatus, setMaritalStatus] = useState([]);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [timer, setTimer] = useState(0);
  const [casteCategories, setCasteCategories] = useState([]);
  const [Qualifications, setQualifications] = useState([]);
  const [Engagements, setEngagements] = useState([]);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [selectedMemberId, setSelectedMemberId] = useState("");
  const [pppOtp, setPppOtp] = useState("");
  const [pppVerified, setPppVerified] = useState(false);
  const [pppOtpSent, setPppOtpSent] = useState(false);
  const [pppTxn, setPppTxn] = useState("");
  const [pppSuccessMessage, setPppSuccessMessage] = useState("");
  const [pppErrors, setPppErrors] = useState({});
  const [empData, setEmpData] = useState({});
  const [applicationStatus, setApplicationStatus] = useState(null);

  const [hasExperience, setHasExperience] = useState(""); 
  const [experienceType, setExperienceType] = useState(""); 

  const [expForm, setExpForm] = useState({
    designation: "",
    agencyName: "",
    fromDate: "",
    toDate: "",
    pf: "", 
    pfNumber: "",
    esi: "", 
    esiNumber: "",
    experienceDocument: null,
    existingDocId: "",
    existingDocFileName: "",
  });
  const [isReplacingExpDoc, setIsReplacingExpDoc] = useState(false);
  const [editingExperience, setEditingExperience] = useState(null);

  const [govExperiences, setGovExperiences] = useState([]); 
  const [privateExperiences, setPrivateExperiences] = useState([]);

  const [showView, setShowView] = useState(false);
  const [viewItem, setViewItem] = useState(null); 

  const stepTitles = [
    "PPP Verification",
    "Family Details",
    "Address Details",
    "Contact Information",
    "Other Details",
    "Service Information",
    "Experience Details",
    "Review Details",
    "Undertaking & OTP",
  ];
  const [step, setStep] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});
  const isFirst = step === 0;
  const isLast = step === stepTitles.length - 1;
  
  const goBack = () => {
    if (step === 0) return;
    setStep((s) => Math.max(0, s - 1));
    setFormErrors({});
  };
  
  const goNext = async () => {
    if (applicationStatus === false) {
      toast.error("Registration cannot be edited in the current application status");
      return;
    }
    if (step === 7) {
      setStep((s) => Math.min(stepTitles.length - 1, s + 1));
      return;
    }
    const memberId = formData.memberId || selectedMemberId;
    const selectedMember = familyMembers.find(
      (item) => String(item.value) === String(memberId)
    );
    const verifiedMemberName = selectedMember?.text || formData.verifiedMemberName || "";
    
    const formDataForValidation = {
      ...formData,
      memberId,
      pppVerified,
      hasExperience,
      experienceType,
      savedDischargeDoc,
      isReplacingDischargeDoc,
      expForm: hasExperience === 'Yes' ? expForm : null,
      govExperiences: hasExperience === 'Yes' ? govExperiences : [],
      privateExperiences: hasExperience === 'Yes' ? privateExperiences : []
    };
    
    const { isValid, errors } = validateStep(step, formDataForValidation);
    
    if (!isValid) {
      setFormErrors(errors);
      const firstError = Object.values(errors)[0];
      if (firstError) {
        toast.error(firstError);
      }
      return;
    }

    dispatch(isloading());
    try {
      const res = await saveRegistrationStep(step, {
        formData: {
          ...formData,
          memberId,
          verifiedMemberName,
        },
        memberId,
        verifiedMemberName,
        govExperiences,
        privateExperiences,
      });
      if (res.data?.status !== 200) {
        toast.error(res.data?.message || "Failed to save step");
        return;
      }
      if (step === 5 || step === 6) {
        await loadUserData({ showLoading: false });
      }
      setFormErrors({});
      setStep((s) => Math.min(stepTitles.length - 1, s + 1));
    } catch (error) {
      toast.error(handleAxiosError(error));
    } finally {
      dispatch(isloading());
    }
  };
useEffect(() => {
  scrollToTop();
}, [step]);

useEffect(() => {
  if (editingExperience) {
    scrollToExperienceForm();
  }
}, [editingExperience]);

  const handleExpChange = (e) => {
    const { name, value } = e.target;
     let newValue = value;

    // Apply validation based on field name
    switch (name) {
      case 'designation':
      case 'agencyName':
        newValue = validateName(value);
        break;

     case 'pfNumber':
     case 'esiNumber':
        newValue = validateAlphaNumeric(value);
        break;


      default:
        break;
    }

    setExpForm(prev => ({
      ...prev,
      [name]: newValue
    }));
  };

  const resetExpForm = () => {
    setIsReplacingExpDoc(false);
    setEditingExperience(null);
    setExpForm({
      designation: "",
      agencyName: "",
      fromDate: "",
      toDate: "",
      pf: "",
      pfNumber: "",
      esi: "",
      esiNumber: "",
      experienceDocument: null,
      existingDocId: "",
      existingDocFileName: "",
    });
  };

  const cancelEditExperience = () => {
    resetExpForm();
    setFormErrors((prev) => {
      const {
        designation,
        agencyName,
        fromDate,
        toDate,
        pf,
        pfNumber,
        esi,
        esiNumber,
        experienceDocument,
        ...rest
      } = prev;
      return rest;
    });
  };

  const editExperience = (type, idx, row) => {
    setExperienceType(type);
    setExpForm({
      designation: row.designation || "",
      agencyName: row.agencyName || "",
      fromDate: row.fromDate || "",
      toDate: row.toDate || "",
      pf: row.pf || "",
      pfNumber: row.pfNumber || "",
      esi: row.esi || "",
      esiNumber: row.esiNumber || "",
      experienceDocument: row.document instanceof File ? row.document : null,
      existingDocId: row.existingDocId || "",
      existingDocFileName: row.existingDocFileName || "",
    });
    setIsReplacingExpDoc(false);
    setEditingExperience({ type, index: idx });
    setFormErrors((prev) => {
      const {
        designation,
        agencyName,
        fromDate,
        toDate,
        pf,
        pfNumber,
        esi,
        esiNumber,
        experienceDocument,
        ...rest
      } = prev;
      return rest;
    });
  };

  const handleExperienceDocumentChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) {
      setExpForm((prev) => ({ ...prev, experienceDocument: null }));
      setFormErrors((prev) => ({ ...prev, experienceDocument: "" }));
      return;
    }

    const { valid, message } = validateExperiencePdfFile(file);
    if (!valid) {
      setFormErrors((prev) => ({ ...prev, experienceDocument: message }));
      toast.error(message);
      e.target.value = "";
      return;
    }

    setExpForm((prev) => ({
      ...prev,
      experienceDocument: file,
    }));
    setFormErrors((prev) => ({
      ...prev,
      experienceDocument: "",
    }));
  };

  const viewPrivateExperienceDoc = async (row) => {
    if (row.document instanceof File) {
      const objectUrl = URL.createObjectURL(row.document);
      window.open(objectUrl, "_blank", "noopener,noreferrer");
      return;
    }
    if (!row.existingDocId) {
      toast.error("No experience document available");
      return;
    }
    try {
      dispatch(isloading());
      const objectUrl = await viewExperienceDocument(row.existingDocId);
      window.open(objectUrl, "_blank", "noopener,noreferrer");
    } catch (error) {
      toast.error(handleAxiosError(error));
    } finally {
      dispatch(isloading());
    }
  };

  const addExperience = () => {
    const newErrors = {};
    
    if (hasExperience !== "Yes") {
      newErrors.hasExperience = 'Please select that you have experience';
    }
    
    if (!experienceType) {
      newErrors.experienceType = 'Please select Experience Type';
    } else {
      // Clear experience type error if it was set before
      setFormErrors(prev => ({ ...prev, experienceType: '' }));
    }
    
    // Clear previous experience form errors
    const expFormErrors = {};
    if (!expForm.designation) expFormErrors.designation = 'Designation is required';
    if (!expForm.agencyName) expFormErrors.agencyName = 'Agency name is required';
    Object.assign(expFormErrors, validateExperienceDates({
      fromDate: expForm.fromDate,
      toDate: expForm.toDate,
    }));
    
    // If there are any errors, set them and return
    if (Object.keys(newErrors).length > 0 || Object.keys(expFormErrors).length > 0) {
      setFormErrors({
        ...formErrors,
        ...newErrors,
        ...expFormErrors
      });
      return;
    }
    
    if (experienceType === 'Private') {
      const privateExpErrors = {};
      if (!expForm.pf) {
        privateExpErrors.pf = 'PF/PRAN status is required';
      } else if (expForm.pf === 'Yes' && !expForm.pfNumber) {
        privateExpErrors.pfNumber = 'PF/PRAN Number is required when PF/PRAN is Yes';
      }

      if (!expForm.esi) {
        privateExpErrors.esi = 'ESI status is required';
      } else if (expForm.esi === 'Yes' && !expForm.esiNumber) {
        privateExpErrors.esiNumber = 'ESI Number is required when ESI is Yes';
      }

      const hasDocument = Boolean(expForm.experienceDocument)
        || (Boolean(expForm.existingDocId) && !isReplacingExpDoc);
      if (!hasDocument) {
        privateExpErrors.experienceDocument = 'Experience document is required for private experience';
      }

      if (Object.keys(privateExpErrors).length > 0) {
        setFormErrors(prev => ({
          ...prev,
          ...privateExpErrors
        }));
        return;
      }
    }

    if (experienceType === "Government") {
      // Check for government-specific fields
      const govErrors = {};
      if (!expForm.pf) {
        govErrors.pf = 'PF status is required';
      } else if (expForm.pf === 'Yes' && !expForm.pfNumber) {
        govErrors.pfNumber = 'PF Number is required when PF is Yes';
      }
      
      if (!expForm.esi) {
        govErrors.esi = 'ESI status is required';
      } else if (expForm.esi === 'Yes' && !expForm.esiNumber) {
        govErrors.esiNumber = 'ESI Number is required when ESI is Yes';
      }
      
      if (Object.keys(govErrors).length > 0) {
        setFormErrors(prev => ({
          ...prev,
          ...govErrors
        }));
        return;
      }
      const item = {
        designation: expForm.designation,
        agencyName: expForm.agencyName,
        fromDate: expForm.fromDate,
        toDate: expForm.toDate,
        pf: expForm.pf,
        pfNumber: expForm.pf === "Yes" ? expForm.pfNumber : "",
        esi: expForm.esi,
        esiNumber: expForm.esi === "Yes" ? expForm.esiNumber : "",
      };
      if (editingExperience?.type === "Government") {
        const existing = govExperiences[editingExperience.index];
        setGovExperiences((prev) =>
          prev.map((entry, i) =>
            i === editingExperience.index ? { ...item, id: existing?.id } : entry
          )
        );
      } else {
        setGovExperiences((prev) => [...prev, item]);
      }
    } else {
      const item = {
        designation: expForm.designation,
        agencyName: expForm.agencyName,
        fromDate: expForm.fromDate,
        toDate: expForm.toDate,
        pf: expForm.pf,
        pfNumber: expForm.pf === "Yes" ? expForm.pfNumber : "",
        esi: expForm.esi,
        esiNumber: expForm.esi === "Yes" ? expForm.esiNumber : "",
        document: expForm.experienceDocument || null,
        existingDocId: expForm.existingDocId || "",
        existingDocFileName: expForm.existingDocFileName || "",
      };
      if (editingExperience?.type === "Private") {
        const existing = privateExperiences[editingExperience.index];
        setPrivateExperiences((prev) =>
          prev.map((entry, i) =>
            i === editingExperience.index ? { ...item, id: existing?.id } : entry
          )
        );
      } else {
        setPrivateExperiences((prev) => [...prev, item]);
      }
    }

    toast.success(editingExperience ? "Experience updated." : "Experience added.");
    resetExpForm();
    // setExperienceType("");
  };

  const deleteExperience = (type, idx) => {
    if (editingExperience?.type === type && editingExperience.index === idx) {
      cancelEditExperience();
    } else if (editingExperience?.type === type && editingExperience.index > idx) {
      setEditingExperience((prev) => ({ ...prev, index: prev.index - 1 }));
    }
    if (type === "Government") {
      setGovExperiences((prev) => prev.filter((_, i) => i !== idx));
    } else {
      setPrivateExperiences((prev) => prev.filter((_, i) => i !== idx));
    }
  };

  const openView = (type, data) => {
    setViewItem({ type, data });
    setShowView(true);
  };

  const closeView = () => {
    setShowView(false);
    setViewItem(null);
  };


  const fetchData = async () => {
    try {
      const res = await AxiosInstance.get(`${BaseUrl}/api/master/all`);
      
        if (res.data) {
          setStates(Array.isArray(res.data.states) ? res.data.states : []);
          
          setMedical(Array.isArray(res.data.medicalCategories) ? res.data.medicalCategories : []);
          
          setGenders(Array.isArray(res.data.gender) ? res.data.gender : []);
          setMaritalStatus(Array.isArray(res.data.maritalStatus) ? res.data.maritalStatus : []);
          setCasteCategories(Array.isArray(res.data.casteCategories) ? res.data.casteCategories : []);
          setQualifications(Array.isArray(res.data.qualifications) ? res.data.qualifications : []);
          setEngagements(Array.isArray(res.data.engagements) ? res.data.engagements : []);
          
          setDistricts(Array.isArray(res.data.districts) ? res.data.districts : []);
          setTehsils(Array.isArray(res.data.tehsils) ? res.data.tehsils : []);
        }

      const resRank = await AxiosInstance.get(`${BaseUrl}/api/master/rank-hierarchy`);
      if (resRank.data) {
        setRankHierarchyData(Array.isArray(resRank.data.data) ? resRank.data.data : []);
        if (resRank.data.force) {
          setForces([resRank.data.force]);
        }
        // Set all services from rankHierarchyData
        const uniqueServices = [...new Set(resRank.data.data.map(item => item.service))];
        setServices(uniqueServices);
      }
    } catch (error) {
      handleAxiosError(error);
    } finally {
      dispatch(isloading());
    }
  };


  const applyUserDataPrefill = (userData) => {
    if (!userData?.editAllowed) return;

    if (userData.id) {
      setIsExServiceman("Yes");
    }

    setFormData(prev => ({
      ...prev,
      forceNumber: userData.forceNumber || '',
      forceName: userData.forceName || '',
      service: userData.service || '',
      type: userData.type || '',
      rank: userData.rank || '',
      fullName: userData.fullName || '',
      medicalCategory: userData.medicalCategory || '',
      dischargeDate: userData.dischargeDate || '',
      dischargeBookNo: userData.dischargeBookNo || '',
      unitRetired: userData.unitRetired || '',
      fatherName: userData.fatherName || '',
      motherName: userData.motherName || '',
      dob: userData.dob || '',
      gender: userData.gender || '',
      maritalStatus: userData.maritalStatus || '',
      state: userData.state || '',
      district: userData.district || '',
      tehsil: userData.tehsil || '',
      village: userData.village || '',
      address: userData.address || '',
      pinCode: userData.pinCode || '',
      email: userData.email || '',
      mobile: userData.mobile || '',
      altMobile: userData.altMobile || '',
      benchmarkDisability: userData.benchmarkDisability || '',
      casteCategoryId: userData.casteCategoryId || '',
      casteCategoryOther: userData.casteCategoryOther || '',
      qualificationId: userData.highestQualificationId || '',
      qualificationOther: userData.qualificationOther || '',
      engagementId: userData.currentEngagementId || '',
      engagementOther: userData.engagementOther || '',
      totalAnnualFamilyIncome: userData.totalAnnualFamilyIncome || '',
      incomeVerified: userData.incomeVerified || '',
      coveredUnderSocioEconomic: userData.coveredUnderSocioEconomic || '',
      ppoNo: userData.ppoNo || '',
      ppoDate: userData.ppoDate || '',
      pppId: userData.pppId || '',
      memberId: userData.memberId || '',
      verifiedMemberName: userData.verifiedMemberName || '',
      pppIdEnabled: (userData.pppVerified || userData.pppId) ? true : prev.pppIdEnabled,
    }));

    if (userData.pppVerified) {
      setPppVerified(true);
      setSelectedMemberId(userData.memberId || "");
      setPppSuccessMessage("PPP Verified");
    } else {
      setPppVerified(false);
    }

    if (userData.stateCode) {
      setFormData(prev => ({ ...prev, state: { code: userData.stateCode, name: userData.state } }));
    }
    if (userData.districtCode) {
      setFormData(prev => ({ ...prev, district: { code: userData.districtCode, name: userData.district } }));
    }
    if (userData.tehsilCode) {
      setFormData(prev => ({ ...prev, tehsil: { code: userData.tehsilCode, name: userData.tehsil } }));
    }

    const dischargeDoc = findSavedDischargeDoc(userData.documents);
    setSavedDischargeDoc(dischargeDoc);
    setIsReplacingDischargeDoc(false);
    setFormData((prev) => ({ ...prev, dischargePdf: null }));

    if (userData.experience && userData.experience.length > 0) {
      const govExps = userData.experience.filter(exp => exp.experienceType === 'GOVERNMENT');
      const privateExps = userData.experience.filter(exp => exp.experienceType === 'PRIVATE');

      setGovExperiences(govExps.map(exp => ({
        id: exp.id || '',
        designation: exp.designation || '',
        agencyName: exp.agencyName || '',
        fromDate: exp.fromDate || '',
        toDate: exp.toDate || '',
        pf: exp.pf || '',
        pfNumber: exp.pfNumber || '',
        esi: exp.esi || '',
        esiNumber: exp.esiNumber || ''
      })));

      setPrivateExperiences(privateExps.map(exp => ({
        id: exp.id || '',
        designation: exp.designation || '',
        agencyName: exp.agencyName || '',
        fromDate: exp.fromDate || '',
        toDate: exp.toDate || '',
        pf: exp.pf || '',
        pfNumber: exp.pfNumber || '',
        esi: exp.esi || '',
        esiNumber: exp.esiNumber || '',
        existingDocId: exp.docId || '',
        existingDocFileName: exp.docFileName || '',
      })));

      setHasExperience('Yes');
      setExperienceType(govExps.length > 0 ? 'Government' : 'Private');
    }

    if (userData.service && rankHierarchyData.length > 0) {
      const uniqueTypes = [...new Set(rankHierarchyData
        .filter(item => item.service === userData.service)
        .map(item => item.type))];
      setTypes(uniqueTypes);

      if (userData.type) {
        const uniqueRanks = [...new Set(rankHierarchyData
          .filter(item => item.service === userData.service && item.type === userData.type)
          .map(item => item.rank))];
        setRanks(uniqueRanks);
      }
    }
  };

  const loadUserData = async ({ showLoading = true } = {}) => {
    if (showLoading) dispatch(isloading());
    try {
      const res = await fetchUserRegistrationData();
      const userData = res?.data?.data;
      setEmpData(userData);
      setApplicationStatus(userData != null ? Boolean(userData.editAllowed) : false);
      applyUserDataPrefill(userData);
      return userData;
    } catch (error) {
      handleAxiosError(error);
      return null;
    } finally {
      if (showLoading) dispatch(isloading());
    }
  };

  const fetchStatusData = () => loadUserData();

    useEffect(()=>{
       fetchStatusData()
    },[dispatch])

  useEffect(() => {
    if (!shouldLoadForm) return;
    loadUserData({ showLoading: false });
  }, [step, shouldLoadForm]);

  useEffect(() => {
    if (!shouldLoadForm) return;
    dispatch(isloading());
    fetchData();
  }, [dispatch, shouldLoadForm]);

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((p) => p - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (formErrors[name]) {
      setFormErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }

    if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
      return;
    }

    let newValue = value;

    switch (name) {
      case 'fullName':
      case 'fatherName':
      case 'motherName':
      case 'forceName':
      case 'unitRetired':
        newValue = validateName(value);
        break;
      case 'service':
        if (value && rankHierarchyData.length > 0) {
          const serviceName = typeof value === 'string' ? value : value?.name || value;
          const uniqueTypes = [...new Set(rankHierarchyData
            .filter(item => item.service === serviceName)
            .map(item => item.type))];
          setTypes(uniqueTypes);
          setRanks([]);
        } else {
          setTypes([]);
          setRanks([]);
        }
        break;
      case 'type':
        if (value && formData.service && rankHierarchyData.length > 0) {
          const typeName = typeof value === 'string' ? value : value?.name || value;
          const serviceName = typeof formData.service === 'string' ? formData.service : formData.service?.name || formData.service;
          const uniqueRanks = [...new Set(rankHierarchyData
            .filter(item => item.service === serviceName && item.type === typeName)
            .map(item => item.rank))];
          setRanks(uniqueRanks);
        } else {
          setRanks([]);
        }
        break;
        
      // case 'mobile':
      case 'altMobile':
        newValue = validateNumeric(value, 10);
        break;
        
      case 'pinCode':
        newValue = validateNumeric(value, 6);
        break;
        
      case 'otp':
        newValue = validateNumeric(value, 6);
        break;

      case 'ppoNo':
        newValue = validateNumeric(value, 12);
        break;
        
      case 'pppId':
      case 'memberId':
      case 'ppoNo':
      case 'forceNumber':
      case 'dischargeBookNo':
        newValue = validateAlphaNumeric(value);
        break;
        
      case 'address':
      case 'village':
        newValue = validateAddress(value);
        break;
        
      case 'email':
        break;
        
      case 'totalAnnualFamilyIncome':
        newValue = validateNumeric(value);
        break;
        
      default:
        break;
    }

    setFormData(prev => ({
      ...prev,
      [name]: newValue
    }));
  };

 const handleStateChange = (e) => {
  const { name, value } = e.target;
  const selectedState = states.find(state => state.code === value);
  
  setFormData(prev => {
    const updates = { 
      [name]: selectedState,
      district: "",
      tehsil: "",
      village: "",
      pinCode: ""
    };
    return { ...prev, ...updates };
  });
  
  if (formErrors[name]) {
    setFormErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[name];
      return newErrors;
    });
  }
};

const handleDistrictChange = (e) => {
  const { name, value } = e.target;
  const selectedDistrict = districts.find(district => district.code === value);
  
  setFormData(prev => {
    const updates = { 
      [name]: selectedDistrict,
      tehsil: "",
      village: "",
      pinCode: ""
    };
    return { ...prev, ...updates };
  });
  
  if (formErrors[name]) {
    setFormErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[name];
      return newErrors;
    });
  }
};

const handleTehsilChange = (e) => {
  const { name, value } = e.target;
  const selectedTehsil = tehsils.find(tehsil => tehsil.code === value);
  
  setFormData(prev => {
    const updates = { 
      [name]: selectedTehsil,
      village: "",
      pinCode: ""
    };
    return { ...prev, ...updates };
  });
  
  if (formErrors[name]) {
    setFormErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[name];
      return newErrors;
    });
  }
};
  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    
    setFormErrors(prev => ({ ...prev, dischargePdf: '' }));
    
    if (!file) {
      setFormData(prev => ({ ...prev, dischargePdf: null }));
      return;
    }

    const { valid, message } = validateDischargePdfFile(file);
    if (!valid) {
      setFormErrors(prev => ({ ...prev, dischargePdf: message }));
      toast.error(message);
      e.target.value = "";
      return;
    }

    setFormData(prev => ({ 
      ...prev, 
      dischargePdf: file 
    }));
  };

  const handleStartReplaceDischargeDoc = () => {
    setIsReplacingDischargeDoc(true);
    setFormData(prev => ({ ...prev, dischargePdf: null }));
    setFormErrors(prev => ({ ...prev, dischargePdf: '' }));
  };

  const handleCancelReplaceDischargeDoc = () => {
    setIsReplacingDischargeDoc(false);
    setFormData(prev => ({ ...prev, dischargePdf: null }));
    setFormErrors(prev => ({ ...prev, dischargePdf: '' }));
  };

  const sendOtp = async () => {
    // const { mobile } = formData;
    // if (!/^[6-9]\d{9}$/.test(mobile)) {
    //   toast.error("Enter a valid 10-digit mobile number starting with 6-9");
    //   return;
    // }
    setIsSendingOtp(true);
        dispatch(isloading());
    try {
      const res = await AxiosInstance.post(
        `${BaseUrl}/api/auth/send-otp`,
        // { mobileNo: mobile },
        { headers: { "Content-Type": "application/json" } }
      );
      if (res.data && res.data.status === 200) {
        toast.success(res.data.message);
        setIsOtpSent(true);
        setTimer(60);
        setFormData((prev) => ({ ...prev, otp: "" }));
      } else {
        toast.error((res.data && res.data.message) || "Failed to send OTP");
      }
    } catch (err) {
      toast.error((err && err.response && err.response.data && err.response.data.message) || "Server error");
    } finally {
      setIsSendingOtp(false);
      setTimer(60);
      setFormData((prev) => ({ ...prev, otp: "" }));
        dispatch(isloading());
    }
  };

  const fetchFamilyMembers = async () => {
    if (!formData.pppId) {
      setPppErrors({ pppId: "PPP ID is required" });
      return;
    }
        dispatch(isloading());
    setPppErrors({});
    setPppSuccessMessage("");
    try {
      const response = await AxiosInstance.post(
        `${BaseUrl}/api/get-applications`, { familyId: formData.pppId },
       
      );
      
      if (response.data && response.data.status === 200) {
        setFamilyMembers(response.data.data || []);
        setPppSuccessMessage(response.data.message || "Family members fetched successfully");
      } else {
        setPppErrors({ fetchError: response.data?.message || "Failed to fetch family members" });
      }
    } catch (error) {
      const errorMessage = handleAxiosError(error);
      setPppErrors({ fetchError: errorMessage });
    }finally{
        dispatch(isloading());
      }
  };

  const sendPppOtp = async () => {
    if (!selectedMemberId) {
      setPppErrors({ selectedMemberId: "Please select a family member" });
      return;
    }
        dispatch(isloading());
    setPppErrors({});
    setPppSuccessMessage("");
    
    try {
      const response = await AxiosInstance.post(
        `${BaseUrl}/api/otp-request`,
        { 
          memberId: selectedMemberId 
        }
      );
      
      if (response.data && response.data.status === 200) {
        setPppOtpSent(true);
        setPppTxn(response.data?.data?.txn || "");
        setPppSuccessMessage(response.data?.data?.message || "OTP sent successfully");
      } else {
        setPppErrors({ otpError: response.data?.message || "Failed to send OTP" });
      }
    } catch (error) {
      const errorMessage = handleAxiosError(error);
      setPppErrors({ otpError: errorMessage });
    }finally{
        dispatch(isloading());
      }
  };

  const verifyPppOtp = async () => {
    if (pppOtp.length !== 6) {
      setPppErrors({ otp: "Please enter a valid 6-digit OTP" });
      return;
    }
    if (!pppTxn) {
      setPppErrors({ otp: "Transaction ID missing. Please request OTP again." });
      return;
    }
        dispatch(isloading());
    setPppErrors({});
    setPppSuccessMessage("");
    
    try {
      const response = await AxiosInstance.post(
        `${BaseUrl}/api/otp-validate`,
        {
          otp: pppOtp,
          txn: pppTxn,
          memberId: selectedMemberId
        }
      );
      
      if (response.data && response.data.status === 200) {
        const selectedMember = familyMembers.find(
          (member) => String(member.value) === String(selectedMemberId)
        );
        setPppVerified(true);
        setPppOtp("");
        setFormData((prev) => ({
          ...prev,
          memberId: selectedMemberId,
          verifiedMemberName: selectedMember?.text || prev.verifiedMemberName || "",
        }));
        const successMessage = response.data.message || "PPP Verified Successfully";
        setPppSuccessMessage(successMessage);
        toast.success(successMessage);
      } else {
        const errorMessage = response.data?.message || "OTP verification failed";
        setPppErrors({ otp: errorMessage });
        toast.error(errorMessage);
      }
    } catch (error) {
      const errorMessage = handleAxiosError(error);
      setPppErrors({ otp: errorMessage });
      toast.error(errorMessage);
    }finally{
        dispatch(isloading());
      }
  };

  const resetPPPVerification = () => {
    setFormData((p) => ({ ...p, pppId: "", memberId: "", verifiedMemberName: "" }));
    setFamilyMembers([]);
    setSelectedMemberId("");
    setPppOtp("");
    setPppOtpSent(false);
    setPppVerified(false);
    setPppSuccessMessage("");
    setPppErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (applicationStatus === false) {
      toast.error("Registration cannot be edited in the current application status");
      return;
    }

    if (!shouldLoadForm) {
      toast.error("Only ex-servicemen can register.");
      return;
    }
        dispatch(isloading());
    // Validate all steps before submission
    let allValid = true;
    const allErrors = {};
    
    for (let i = 0; i < stepTitles.length; i++) {
      const formDataForValidation = {
        ...formData,
        pppVerified,
        hasExperience,
        experienceType,
        savedDischargeDoc,
        isReplacingDischargeDoc,
        expForm: hasExperience === 'Yes' ? expForm : null,
        govExperiences: hasExperience === 'Yes' ? govExperiences : [],
        privateExperiences: hasExperience === 'Yes' ? privateExperiences : []
      };
      
      const { isValid, errors } = validateStep(i, formDataForValidation);
      if (!isValid) {
        allValid = false;
        Object.assign(allErrors, errors);
      }
    }
    
    if (!allValid) {
      setFormErrors(allErrors);
      const firstError = Object.values(allErrors)[0];
      if (firstError) {
        toast.error(`Please fix the following error: ${firstError}`);
      }
      return;
    }

    const submitData = buildRegistrationFormData({
      formData,
      govExperiences,
      privateExperiences,
    });
    submitData.append("regType", "ESM");

    try {
      const registerRes = await AxiosInstance.post(
        `${BaseUrl}/api/auth/registration`,
        submitData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (registerRes.data && registerRes.data.status === 200) {
        toast.success("Registration successful!");
        // navigate("/login");
        fetchStatusData();
      } else {
        toast.error((registerRes.data && registerRes.data.message) || "Registration failed");
      }
    } catch (err) {
      toast.error((err && err.response && err.response.data && err.response.data.message) || "Registration failed");
    }finally{
        dispatch(isloading());
      }
  };

  if (applicationStatus === null) {
    return null;
  }

  if (!applicationStatus) {
    return <EmployeeEsmFormView data={empData} />;
  }


  if (!shouldLoadForm) {
    return (
      <div className="container" >
        <div className="p-4 mx-5 my-4 shadow-lg rounded-3">
          <h2 className="mb-4 text-center" style={{ color: "grey" }}>
            ESM Member Registration
          </h2>

          <div className="row justify-content-center">
            <div className="col-md-6 mb-3">
              <label className="form-label fw-semibold">Are you an Ex-Serviceman?</label>
              <select
                className="form-select"
                value={isExServiceman}
                onChange={(e) => setIsExServiceman(e.target.value)}
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>

              {isExServiceman === "No" && (
                <div className="alert alert-info mt-3">
                  This registration is currently available only for Ex-Serviceman.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  const getMaxDate = () => {
  const today = new Date();
  const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
  return maxDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
};

  return (
    <div className="container" ref={topRef}>
      <div className="p-4 mx-5 my-4 shadow-lg rounded-3">
        <h2 className="mb-2 text-center" style={{ color: "grey" }}>
          ESM Member Registration
        </h2>

        {/* Progress Header (UI only) */}
        <div className="text-center mb-3">
          <small className="text-muted">
            Step {step + 1} of {stepTitles.length} — <strong>{stepTitles[step]}</strong>
          </small>
          <div className="progress mt-2" role="progressbar" aria-valuenow={((step+1)/stepTitles.length)*100}>
            <div
              className="progress-bar"
              style={{ width: `${((step + 1) / stepTitles.length) * 100}%` }}
            />
          </div>
        </div>

        <form onSubmit={handleSubmit} encType="multipart/form-data" className="needs-validation">
          {/* STEP 0: PPP Verification */}
          {step === 0 && (
            <div className="mb-4 p-3 border rounded">
              <h5 className="mb-3 text-secondary">PPP Verification </h5>

              <div className="mb-3">
                 <div className="form-check mb-2">
    <input 
      type="checkbox" 
      className="form-check-input" 
      id="pppCheckbox"
      checked={formData.pppIdEnabled || false}
      onChange={(e) => {
        setFormData(p => ({ 
          ...p, 
          pppIdEnabled: e.target.checked,
          pppId: e.target.checked ? p.pppId : '' // Clear PPP ID when unchecked
        }));
      }}
    />
    <label className="form-check-label text-danger" htmlFor="pppCheckbox">
      I am willing to provide my PPP ID.
    </label>
  </div>
                <label className="form-label">PPP ID</label>
                <input
                  name="pppId"
                  maxLength={8}
                  className={`form-control ${pppErrors.pppId ? "is-invalid" : ""}`}
                  value={formData.pppId}
                  onChange={(e) =>
                    setFormData((p) => ({ ...p, pppId: e.target.value }))
                  }
                  onKeyPress={(e) => {
                    if (!/[A-Za-z0-9]/.test(e.key)) e.preventDefault();
                  }}
                  disabled={!formData.pppIdEnabled || pppVerified}
                  placeholder={formData.pppIdEnabled ? "Enter PPP ID" : "Please check the box above to enter PPP ID"}
                  required={formData.pppIdEnabled}
                />
                {pppErrors.pppId && (
                  <div className="invalid-feedback">{pppErrors.pppId}</div>
                )}
              </div>

              {pppVerified && formData.memberId && (
                <div className="mb-3">
                  <label className="form-label">Member ID</label>
                  <input
                    type="text"
                    value={formData.memberId}
                    disabled
                    className="form-control bg-light"
                  />
                </div>
              )}

              <div className="mb-3 d-flex gap-2">
                <button
                  type="button"
                  onClick={fetchFamilyMembers}
                  disabled={familyMembers.length > 0 ||pppVerified || !formData.pppId}
                  className="btn btn-primary btn-md w-auto"
                >
                  Fetch Family Members
                </button>

                {pppVerified && (
                  <button
                    type="button"
                    onClick={resetPPPVerification}
                    className="btn btn-success btn-md w-auto"
                  >
                    Reset PPP
                  </button>
                )}
              </div>

              {familyMembers.length > 0 && (
                <>
                  <div className="mb-3">
                    <label className="form-label">Select Family Member</label>
                    <select
                      value={selectedMemberId}
                      onChange={(e) => setSelectedMemberId(e.target.value)}
                      disabled={pppOtpSent || pppVerified}
                      className={`form-select ${
                        pppErrors.selectedMemberId ? "is-invalid" : ""
                      }`}
                    >
                      <option value="">-- Select Member --</option>
                      {familyMembers.map((m) => (
                        <option key={m.value} value={m.value}>
                          {m.text}
                        </option>
                      ))}
                    </select>
                    {pppErrors.selectedMemberId && (
                      <div className="invalid-feedback">
                        {pppErrors.selectedMemberId}
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    <button
                      type="button"
                      onClick={sendPppOtp}
                      disabled={pppOtpSent || pppVerified || !selectedMemberId}
                      className="btn btn-primary btn-md w-auto"
                    >
                      {pppOtpSent ? "OTP Sent" : "Send OTP "}
                    </button>
                  </div>
                </>
              )}

              {pppOtpSent && !pppVerified && (
                <div className="mb-3">
                  <label className="form-label">Enter OTP</label>
                  <input
                    type="text"
                    maxLength={6}
                    className={`form-control ${pppErrors.otp ? "is-invalid" : ""}`}
                    placeholder="Enter OTP "
                    value={pppOtp}
                    onChange={(e) => setPppOtp(validateNumeric(e.target.value, 6))}
                  />
                  {pppErrors.otp && (
                    <div className="invalid-feedback">{pppErrors.otp}</div>
                  )}

                  <button
                    type="button"
                    onClick={verifyPppOtp}
                    disabled={!pppOtp}
                    className="btn btn-primary mt-2 btn-md w-auto"
                  >
                    Verify OTP 
                  </button>
                </div>
              )}

              {pppSuccessMessage && pppVerified &&(
                <p className="text-success fw-medium">✅ {pppSuccessMessage}</p>
              )}
            </div>
          )}

          {/* STEP 1: Family Details */}
          {step === 1 && (
            <>
              <h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
                Family Details
              </h5>
              <div className="row">
                <div className="col-md-6">
                  <FormField
                    label="Full Name"
                    name="fullName"
                    type="text"
                    value={formData.fullName}
                    onChange={handleChange}
                    error={formErrors.fullName}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Father's Name"
                    name="fatherName"
                    type="text"
                    value={formData.fatherName}
                    onChange={handleChange}
                    error={formErrors.fatherName}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Mother's Name"
                    name="motherName"
                    type="text"
                    value={formData.motherName}
                    onChange={handleChange}
                    error={formErrors.motherName}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Date of Birth"
                    name="dob"
                    type="date"
                    value={formData.dob}
                    onChange={handleChange}
                    max={getMaxDate()}
                    error={formErrors.dob}
                    required
                    onKeyDown={(e) => e.preventDefault()}
                  />
                  {formData.dob && new Date(formData.dob) > new Date(getMaxDate()) && (
                    <div className="text-danger small mt-1">
                      You must be at least 18 years old to register.
                    </div>
                  )}
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Gender"
                    name="gender"
                    type="select"
                    value={formData.gender || ""}
                    onChange={handleChange}
                    error={formErrors.gender}
                    options={genders.map(g => ({ value: g, label: g }))}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <FormField
                    label="Marital Status"
                    name="maritalStatus"
                    type="select"
                    value={formData.maritalStatus || ""}
                    onChange={handleChange}
                    error={formErrors.maritalStatus}
                    options={maritalStatus.map(m => ({ value: m, label: m }))}
                    required
                  />
                </div>
              </div>
            </>
          )}

          {/* STEP 2: Address Details */}
          {step === 2 && (
            <>
              <h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
                Address Details
              </h5>
              <div className="row">
                <div className="col-md-6">
                  <FormField
                    label="State"
                    name="state"
                    type="select"
                    value={formData.state?.code || ''}
                    onChange={handleStateChange}
                    error={formErrors.state}
                    options={states?.map(state => ({ value: state.code, label: state.name })) || []}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="District"
                    name="district"
                    type="select"
                    value={formData.district?.code || ''}
                    onChange={handleDistrictChange}
                    error={formErrors.district}
                    options={districts?.filter(district => district.parentId === formData.state?.code)?.map(district => ({ value: district.code, label: district.name })) || []}
                    disabled={!formData.state}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Tehsil"
                    name="tehsil"
                    type="select"
                    value={formData.tehsil?.code || ''}
                    onChange={handleTehsilChange}
                    error={formErrors.tehsil}
                    options={tehsils?.filter(tehsil => tehsil.parentId === formData.district?.code)?.map(tehsil => ({ value: tehsil.code, label: tehsil.name })) || []}
                    disabled={!formData.district}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Village/Ward No/Colony"
                    name="village"
                    type="text"
                    value={formData.village}
                    onChange={handleChange}
                    error={formErrors.village}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Permanent Home Address"
                    name="address"
                    type="textarea"
                    value={formData.address}
                    onChange={handleChange}
                    error={formErrors.address}
                    rows={3}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="PIN Code"
                    name="pinCode"
                    type="text"
                    value={formData.pinCode}
                    onChange={handleChange}
                    error={formErrors.pinCode}
                    maxLength={6}
                    required
                  />
                </div>
                
              </div>
            </>
          )}
{/* STEP 3: Contact Information */}
{step === 3 && (
  <>
    <h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
      Contact Information
    </h5>
    <div className="row">
      <div className="col-md-6 mb-3">
        <FormField
          label="Email Address"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          error={formErrors.email}
          placeholder="Enter your email address"
          required
          disabled={isOtpSent}
        />
      </div>
      {/* <div className="col-md-6 mb-3">
        <FormField
          label="Mobile Number"
          name="mobile"
          type="tel"
          value={formData.mobile}
          onChange={handleChange}
          error={formErrors.mobile}
          placeholder="Enter 10-digit mobile number"
          maxLength={10}
          required
          disabled={isOtpSent}
        />
      </div> */}
      <div className="col-md-6 mb-3">
        <FormField
          label="Alternate Mobile Number (Optional)"
          name="altMobile"
          type="tel"
          value={formData.altMobile}
          onChange={handleChange}
          error={formErrors.altMobile}
          placeholder="Enter alternate mobile number"
          maxLength={10}
          disabled={isOtpSent}
        />
      </div>
    </div>
  </>
)}
          {/* STEP 4: Other Details */}
         {/* STEP 4: Other Details */}
{step === 4 && (
  <>
    <h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
      Other Details
    </h5>
    <div className="row">
      <div className="col-md-6 mb-3">
        <FormField
          label="Benchmark Disability"
          name="benchmarkDisability"
          type="select"
          value={formData.benchmarkDisability || ''}
          onChange={handleChange}
          error={formErrors.benchmarkDisability}
          options={[
            { value: 'Yes', label: 'Yes' },
            { value: 'No', label: 'No' }
          ]}
          required
        />
      </div>

      <div className="col-md-6 mb-3">
        <FormField
          label="Caste Category"
          name="casteCategoryId"
          type="select"
          value={formData.casteCategoryId}
          onChange={handleChange}
          error={formErrors.casteCategoryId}
          options={casteCategories.map((c) => ({ value: c.code, label: c.name }))}
          required
        />
      </div>

      <div className="col-md-6 mb-3">
        <FormField
          label="Highest Qualification"
          name="qualificationId"
          type="select"
          value={formData.qualificationId}
          onChange={handleChange}
          error={formErrors.qualificationId}
          options={Qualifications.map(q => ({ value: q.code, label: q.name }))}
          required
        />
      </div>

      <div className="col-md-6 mb-3">
        <FormField
          label="Current Engagement"
          name="engagementId"
          type="select"
          value={formData.engagementId}
          onChange={handleChange}
          error={formErrors.engagementId}
          options={Engagements.map((e) => ({ value: e.code, label: e.name }))}
          required
        />
      </div>

      <div className="col-md-6 mb-3">
        <FormField
          label="Total Annual Family Income (₹)"
          name="totalAnnualFamilyIncome"
          type="text"
          value={formData.totalAnnualFamilyIncome}
          onChange={handleChange}
          error={formErrors.totalAnnualFamilyIncome}
          placeholder="e.g., 250000"
          required
        />
      </div>

            <div className="col-md-6 mb-3">
            <label className="form-label ">Is Income Verified</label>
          <div className="d-flex align-items-center">
            <FormField
              name="incomeVerified"
              type="radio"
              value="true"
              label="Yes"
              checked={formData.incomeVerified === true || formData.incomeVerified === 'true'}
              onChange={(e) => setFormData(prev => ({ ...prev, incomeVerified: e.target.checked }))}
              inline
              className="me-2"
            />
            <FormField
              name="incomeVerified"
              type="radio"
              value="false"
              label="No"
              checked={formData.incomeVerified === false || formData.incomeVerified === 'false'}
              onChange={(e) => setFormData(prev => ({ ...prev, incomeVerified: !e.target.checked }))}
              inline
            />
          </div>
          {formErrors.incomeVerified && (
            <div className="invalid-feedback d-block">{formErrors.incomeVerified}</div>
          )}
        </div>
    </div>
  </>
)}

          {/* STEP 5: Service Information */}
          {step === 5 && (
            <>
              <h5 className="mb-3 border-bottom pb-2 text-secondary border-info">
                Service Information
              </h5>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <FormField
                    label="Are you covered under Socio-Economic Criteria?"
                    name="coveredUnderSocioEconomic"
                    type="select"
                    value={formData.coveredUnderSocioEconomic || ''}
                    onChange={handleChange}
                    error={formErrors.coveredUnderSocioEconomic}
                    options={[
                      { value: 'Yes', label: 'Yes' },
                      { value: 'No', label: 'No' }
                    ]}
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <FormField
                    label="Force"
                    name="forceName"
                    type="select"
                    value={typeof formData.forceName === 'string' ? formData.forceName : formData.forceName?.name || formData.forceName || ''}
                    onChange={handleChange}
                    error={formErrors.forceName}
                    options={forces.map(force => ({ value: force, label: force }))}
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <FormField
                    label="Service"
                    name="service"
                    type="select"
                    value={typeof formData.service === 'string' ? formData.service : formData.service?.name || formData.service || ''}
                    onChange={handleChange}
                    error={formErrors.service}
                    options={services.map(service => ({ value: service, label: service }))}
                    disabled={!formData.forceName}
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <FormField
                    label="Type"
                    name="type"
                    type="select"
                    value={typeof formData.type === 'string' ? formData.type : formData.type?.name || formData.type || ''}
                    onChange={handleChange}
                    error={formErrors.type}
                    options={types.map(type => ({ value: type, label: type }))}
                    disabled={!formData.service}
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <FormField
                    label="Rank"
                    name="rank"
                    type="select"
                    value={typeof formData.rank === 'string' ? formData.rank : formData.rank?.name || formData.rank || ''}
                    onChange={handleChange}
                    error={formErrors.rank}
                    options={ranks.map(rank => ({ value: rank, label: rank }))}
                    disabled={!formData.type}
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
               
                  <FormField
                   label="Force/Service Number"
                    name="forceNumber"
                    type="text"
                    value={formData.forceNumber}
                    onChange={handleChange}
                    error={formErrors.forceNumber}
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                 
                  <FormField
                    label="Medical Category"
                    name="medicalCategory"
                    type="select"
                    value={typeof formData.medicalCategory === 'string' ? formData.medicalCategory : formData.medicalCategory?.code || formData.medicalCategory || ''}
                    onChange={handleChange}
                    error={formErrors.medicalCategory}
                    options={medical?.map((item) => ({ value: item.code, label: item.name }))}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <FormField
                    label="Date of Discharge/Retirement"
                    name="dischargeDate"
                    type="date"
                    value={formData.dischargeDate || ''}
                    onChange={handleChange}
                    error={formErrors.dischargeDate}
                    required
                    onKeyDown={(e) => e.preventDefault()}
                    max={new Date(Date.now() - 86400000).toISOString().split('T')[0]}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <FormField
                    label="Discharge Book No"
                    name="dischargeBookNo"
                    type="text"
                    value={formData.dischargeBookNo || ''}
                    onChange={handleChange}
                    error={formErrors.dischargeBookNo}
                    required
                    placeholder="Enter Discharge Book Number"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <FormField
                    label="Name of Unit Retired From"
                    name="unitRetired"
                    type="text"
                    value={formData.unitRetired || ''}
                    onChange={handleChange}
                    error={formErrors.unitRetired}
                    required
                    placeholder="Enter Unit Name"
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <FormField
                    label="PPO No."
                    name="ppoNo"
                    type="text"
                    value={formData.ppoNo || ''}
                    onChange={handleChange}
                    error={formErrors.ppoNo}
                    placeholder="Enter PPO Number"
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <FormField
                    label="PPO Date"
                    name="ppoDate"
                    type="date"
                    value={formData.ppoDate || ''}
                    onChange={handleChange}
                    error={formErrors.ppoDate}
                    onKeyDown={(e) => e.preventDefault()}
                    required
                    max={new Date(Date.now() - 86400000).toISOString().split('T')[0]}
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <DischargeDocumentField
                    savedDoc={savedDischargeDoc}
                    selectedFile={formData.dischargePdf}
                    isReplacing={isReplacingDischargeDoc}
                    error={formErrors.dischargePdf}
                    accept=".pdf,.jpg,.jpeg,.png"
                    onStartReplace={handleStartReplaceDischargeDoc}
                    onCancelReplace={handleCancelReplaceDischargeDoc}
                    onFileChange={handleFileChange}
                  />
                </div>
              </div>
            </>
          )}

          {/* STEP 6: Experience Details */}
          {step === 6 && (
            <>
              <h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
                Experience Details
              </h5>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Do you have any Experience?</label>
                  <div className="d-flex align-items-center">
                    <FormField
                      name="hasExperience"
                      type="radio"
                      value="Yes"
                      label="Yes"
                      checked={hasExperience === 'Yes'}
                      onChange={(e) => {
                        setHasExperience('Yes');
                        // Clear any previous errors
                        setFormErrors(prev => ({ ...prev, hasExperience: '' }));
                      }}
                      inline
                      className="me-2"
                    />
                    <FormField
                      name="hasExperience"
                      type="radio"
                      value="No"
                      label="No"
                      checked={!hasExperience || hasExperience === 'No'}
                      onChange={(e) => {
                        setHasExperience('No');
                        setExperienceType("");
                        resetExpForm();
                        // Clear any previous errors
                        setFormErrors(prev => ({ ...prev, hasExperience: '' }));
                      }}
                      inline
                      defaultChecked
                    />
                  </div>
                  {formErrors.hasExperience && (
                    <div className="invalid-feedback d-block">{formErrors.hasExperience}</div>
                  )}
                </div>

                <div className="col-md-6 mb-3">
                  <FormField
                    label="Experience Type"
                    name="experienceType"
                    type="select"
                    value={experienceType || ''}
                    onChange={(e) => {
                      setExperienceType(e.target.value);
                      resetExpForm();
                      setFormErrors(prev => ({ ...prev, experienceType: '' }));
                    }}
                    disabled={hasExperience !== "Yes"}
                    options={[
                      { value: 'Government', label: 'Government' },
                      { value: 'Private', label: 'Private' }
                    ]}
                    error={formErrors.experienceType}
                  />
                </div>
              </div>

              {hasExperience === "Yes" && experienceType && (
                <div
                  ref={experienceFormRef}
                  tabIndex={-1}
                  className={`border rounded p-3 mb-3 ${
                    editingExperience ? "border-warning border-2 shadow-sm" : ""
                  }`}
                >
                  {editingExperience && (
                    <div className="alert alert-warning py-2 mb-3">
                      <strong>Editing {editingExperience.type} experience #{editingExperience.index + 1}.</strong>{" "}
                      Update the fields below, then click Update Experience or Cancel.
                    </div>
                  )}
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <FormField
                        label="Designation"
                        name="designation"
                        type="text"
                        value={expForm.designation}
                        onChange={(e) => {
                          handleExpChange(e);
                          // Clear the error when user starts typing
                          if (formErrors.designation) {
                            setFormErrors(prev => ({ ...prev, designation: '' }));
                          }
                        }}
                        error={formErrors.designation}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <FormField
                        label="Agency Name"
                        name="agencyName"
                        type="text"
                        value={expForm.agencyName}
                        onChange={(e) => {
                          handleExpChange(e);
                          if (formErrors.agencyName) {
                            setFormErrors(prev => ({ ...prev, agencyName: '' }));
                          }
                        }}
                        error={formErrors.agencyName}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <FormField
                        label="From Date"
                        name="fromDate"
                        type="date"
                        value={expForm.fromDate}
                        onChange={(e) => {
                          handleExpChange(e);
                          if (formErrors.fromDate) {
                            setFormErrors(prev => ({ ...prev, fromDate: '' }));
                          }
                        }}
                        onKeyDown={(e) => e.preventDefault()}
                        error={formErrors.fromDate}
                        max={getTodayMaxDate()}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <FormField
                        label="To Date"
                        name="toDate"
                        type="date"
                        value={expForm.toDate}
                        onChange={(e) => {
                          handleExpChange(e);
                          if (formErrors.toDate) {
                            setFormErrors(prev => ({ ...prev, toDate: '' }));
                          }
                        }}
                        onKeyDown={(e) => e.preventDefault()}
                        error={formErrors.toDate}
                        max={getTodayMaxDate()}
                        min={expForm.fromDate || undefined}
                        required
                      />
                    </div>

                    {experienceType === "Government" && (
                      <>
                        <div className="col-md-6 mb-3">
                          <FormField
                            label="PF"
                            name="pf"
                            type="select"
                            value={expForm.pf}
                            onChange={(e) => {
                              handleExpChange(e);
                              if (formErrors.pf) {
                                setFormErrors(prev => ({ ...prev, pf: '' }));
                              }
                            }}
                            options={[
                              { value: 'Yes', label: 'Yes' },
                              { value: 'No', label: 'No' }
                            ]}
                            error={formErrors.pf}
                            required
                          />
                        </div>
                        {expForm.pf === "Yes" && (
                          <div className="col-md-6 mb-3">
                            <FormField
                              label="PF Number"
                              name="pfNumber"
                              type="text"
                              value={expForm.pfNumber}
                              onChange={(e) => {
                                handleExpChange(e);
                                if (formErrors.pfNumber) {
                                  setFormErrors(prev => ({ ...prev, pfNumber: '' }));
                                }
                              }}
                              error={formErrors.pfNumber}
                              required
                            />
                          </div>
                        )}

                        <div className="col-md-6 mb-3">
                          <FormField
                            label="ESI"
                            name="esi"
                            type="select"
                            value={expForm.esi}
                            onChange={(e) => {
                              handleExpChange(e);
                              if (formErrors.esi) {
                                setFormErrors(prev => ({ ...prev, esi: '' }));
                              }
                            }}
                            options={[
                              { value: 'Yes', label: 'Yes' },
                              { value: 'No', label: 'No' }
                            ]}
                            error={formErrors.esi}
                            required
                          />
                        </div>
                        {expForm.esi === "Yes" && (
                          <div className="col-md-6 mb-3">
                            <FormField
                              label="ESI Number"
                              name="esiNumber"
                              type="text"
                              value={expForm.esiNumber}
                              onChange={(e) => {
                                handleExpChange(e);
                                if (formErrors.esiNumber) {
                                  setFormErrors(prev => ({ ...prev, esiNumber: '' }));
                                }
                              }}
                              error={formErrors.esiNumber}
                              required
                            />
                          </div>
                        )}
                      </>
                    )}

                    {experienceType === "Private" && (
                      <>
                        <div className="col-md-6 mb-3">
                          <FormField
                            label="PF/PRAN"
                            name="pf"
                            type="select"
                            value={expForm.pf}
                            onChange={(e) => {
                              handleExpChange(e);
                              if (e.target.value !== "Yes") {
                                setExpForm((prev) => ({ ...prev, pfNumber: "" }));
                              }
                              if (formErrors.pf) {
                                setFormErrors(prev => ({ ...prev, pf: '' }));
                              }
                            }}
                            error={formErrors.pf}
                            required
                            options={[
                              { value: "Yes", label: "Yes" },
                              { value: "No", label: "No" },
                            ]}
                          />
                        </div>
                        {expForm.pf === "Yes" && (
                          <div className="col-md-6 mb-3">
                            <FormField
                              label="PF/PRAN Number"
                              name="pfNumber"
                              type="text"
                              value={expForm.pfNumber}
                              onChange={(e) => {
                                handleExpChange(e);
                                if (formErrors.pfNumber) {
                                  setFormErrors(prev => ({ ...prev, pfNumber: '' }));
                                }
                              }}
                              error={formErrors.pfNumber}
                              required
                            />
                          </div>
                        )}
                        <div className="col-md-6 mb-3">
                          <FormField
                            label="ESI"
                            name="esi"
                            type="select"
                            value={expForm.esi}
                            onChange={(e) => {
                              handleExpChange(e);
                              if (e.target.value !== "Yes") {
                                setExpForm((prev) => ({ ...prev, esiNumber: "" }));
                              }
                              if (formErrors.esi) {
                                setFormErrors(prev => ({ ...prev, esi: '' }));
                              }
                            }}
                            error={formErrors.esi}
                            required
                            options={[
                              { value: "Yes", label: "Yes" },
                              { value: "No", label: "No" },
                            ]}
                          />
                        </div>
                        {expForm.esi === "Yes" && (
                          <div className="col-md-6 mb-3">
                            <FormField
                              label="ESI Number"
                              name="esiNumber"
                              type="text"
                              value={expForm.esiNumber}
                              onChange={(e) => {
                                handleExpChange(e);
                                if (formErrors.esiNumber) {
                                  setFormErrors(prev => ({ ...prev, esiNumber: '' }));
                                }
                              }}
                              error={formErrors.esiNumber}
                              required
                            />
                          </div>
                        )}
                        <div className="col-md-12 mb-3">
                          <ExperienceDocumentField
                            savedDoc={
                              expForm.existingDocId
                                ? {
                                    docId: expForm.existingDocId,
                                    fileName: expForm.existingDocFileName,
                                  }
                                : null
                            }
                            selectedFile={expForm.experienceDocument}
                            isReplacing={isReplacingExpDoc}
                            error={formErrors.experienceDocument}
                            onStartReplace={() => setIsReplacingExpDoc(true)}
                            onCancelReplace={() => {
                              setIsReplacingExpDoc(false);
                              setExpForm((prev) => ({ ...prev, experienceDocument: null }));
                            }}
                            onFileChange={handleExperienceDocumentChange}
                          />
                        </div>
                      </>
                    )}
                  </div>

                  <div className="text-end d-flex gap-2 justify-content-end">
                    {editingExperience && (
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-md w-auto"
                        onClick={cancelEditExperience}
                      >
                        Cancel
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-primary btn-md w-auto"
                      onClick={addExperience}
                    >
                      {editingExperience ? "Update Experience" : "Add Experience"}
                    </button>
                  </div>
                </div>
              )}

              {govExperiences.length > 0 && (
                <>
                  <h6 className="mt-4">Government Experience</h6>
                  <div className="table-responsive">
                    <table className="table table-bordered table-sm align-middle">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Designation</th>
                          <th>Agency</th>
                          <th>From</th>
                          <th>To</th>
                          <th>PF</th>
                          <th>PF No</th>
                          <th>ESI</th>
                          <th>ESI No</th>
                          <th style={{ width: 200 }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {govExperiences.map((row, idx) => (
                          <tr
                            key={`gov-${row.id || idx}`}
                            className={
                              editingExperience?.type === "Government" && editingExperience.index === idx
                                ? "table-warning"
                                : ""
                            }
                          >
                            <td>{idx + 1}</td>
                            <td>{row.designation}</td>
                            <td>{row.agencyName}</td>
                            <td>{row.fromDate}</td>
                            <td>{row.toDate}</td>
                            <td>{row.pf}</td>
                            <td>{row.pfNumber}</td>
                            <td>{row.esi}</td>
                            <td>{row.esiNumber}</td>
                            <td>
                              <div className="d-flex gap-2 flex-wrap">
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-sm w-auto"
                                  onClick={() => openView("Government", row)}
                                >
                                  View
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary btn-sm w-auto"
                                  onClick={() => editExperience("Government", idx, row)}
                                >
                                  Edit
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-outline-danger btn-sm w-auto"
                                  onClick={() => deleteExperience("Government", idx)}
                                >
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}

              {privateExperiences.length > 0 && (
                <>
                  <h6 className="mt-4">Private Experience</h6>
                  <div className="table-responsive">
                    <table className="table table-bordered table-sm align-middle">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Designation</th>
                          <th>Agency</th>
                          <th>From</th>
                          <th>To</th>
                          <th>PF</th>
                          <th>PF No</th>
                          <th>ESI</th>
                          <th>ESI No</th>
                          <th>Document</th>
                          <th style={{ width: 200 }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {privateExperiences.map((row, idx) => (
                          <tr
                            key={`priv-${row.id || idx}`}
                            className={
                              editingExperience?.type === "Private" && editingExperience.index === idx
                                ? "table-warning"
                                : ""
                            }
                          >
                            <td>{idx + 1}</td>
                            <td>{row.designation}</td>
                            <td>{row.agencyName}</td>
                            <td>{row.fromDate}</td>
                            <td>{row.toDate}</td>
                            <td>{row.pf}</td>
                            <td>{row.pfNumber}</td>
                            <td>{row.esi}</td>
                            <td>{row.esiNumber}</td>
                            <td>
                              {(row.document || row.existingDocId) ? (
                                <button
                                  type="button"
                                  className="btn btn-link btn-sm p-0"
                                  onClick={() => viewPrivateExperienceDoc(row)}
                                >
                                  View
                                </button>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>
                              <div className="d-flex gap-2 flex-wrap">
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-sm w-auto"
                                  onClick={() => openView("Private", row)}
                                >
                                  View
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary btn-sm w-auto"
                                  onClick={() => editExperience("Private", idx, row)}
                                >
                                  Edit
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-outline-danger btn-sm w-auto"
                                  onClick={() => deleteExperience("Private", idx)}
                                >
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </>
          )}

          {/* STEP 7: Review Details */}
          {step === 7 && (
            <>
              <div className="mb-3">
                <div className="alert alert-info mb-3">
                  Please review all saved details below. Click <strong>Proceed to Final Submit</strong> to continue with OTP-based submission.
                </div>
                <EmployeeEsmFormView data={empData} showDownloadButton={false} />
              </div>
            </>
          )}

          {/* STEP 8: Undertaking & OTP */}
          {step === 8 && (
            <>
              <ul className="my-4 me-4 " style={{  listStyleType: "decimal",textAlign: "justify",color:"#ca2525"}}>
                <li className="">I have carefully read and checked all the particulars filled up by me against each column above and thereafter saved the same. I fully understandthat if any of these is found false/incorrect then my application form, candidature or appointment shall be liable to be rejected/cancelled.</li>
                <li className="text-justify">I understand and affirm that deployment in a government entity would be governed by the provisions of “Deployment of Contractual PersonsPolicy, 2022” and that appointment in a private entity would be governed by the conditions of the Indent/requisition/Selection criteria specified bythe Indenting Private Sector Entity.</li>
                <li className="">I understand that the for deployment in a government entity “age criteria” as per the provisions of “Deployment of Contractual Persons Policy,2022” shall be applicable and for appointment in Private Sector, “Age Criteria” requirement as per the Indent/Requirement of Indenting PrivateSector Entity shall be applicable.</li>
                <li className="">I understand that for deployment in a government entity, only prior verified government experience would be taken into consideration and in caseof appointment in a private entity, prior experience would be taken into consideration subject to its verification.</li>
              </ul>

              {isOtpSent && (
                <div className="row">
                  <div className="col-md-6 mb-3 mx-auto">
                    <label className="form-label">OTP</label>
                    <input
                      type="text"
                      className="form-control"
                      name="otp"
                      value={formData.otp}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              )}

              <div className="text-center mx-auto">
                {!isOtpSent ? (
                  <button
                    type="button"
                    className="btn btn-primary btn-md w-auto"
                    onClick={sendOtp}
                    disabled={false}
                  >
                    {isSendingOtp ? "Sending OTP..." : "Submit & Send OTP"}
                  </button>
                ) : (
                  <div className="d-flex justify-content-center mt-1">
                    <button type="submit" className="btn btn-success w-auto btn-md">
                      Register
                    </button>
                    <button
                      type="button"
                      className="btn btn-warning ms-4 w-auto btn-md"
                      onClick={sendOtp}
                      disabled={timer > 0}
                    >
                      {timer > 0 ? `Resend OTP (${timer}s)` : "Resend OTP"}
                    </button>
                  </div>
                )}
              </div>
            </>
          )}

          {/* Wizard Controls */}
          <div className="d-flex justify-content-between mt-4">
            <button
              type="button"
              className="btn btn-outline-secondary btn-md w-auto"
              onClick={goBack}
              disabled={isFirst}
            >
              Back
            </button>

            {!isLast && (
              <button
                type="button"
                className="btn btn-primary btn-md w-auto"
                onClick={goNext}
              >
                {step === 7 ? "Proceed to Final Submit" : "Next"}
              </button>
            )}
          </div>
        </form>
      </div>

      {/* Modal (unchanged) */}
      {showView && viewItem && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.3)" }}
          tabIndex="-1"
          onClick={closeView}
        >
          <div
            className="modal-dialog modal-lg modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header bg-light">
                <h5 className="modal-title mb-0">
                  {viewItem.type} Experience Details
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeView}
                ></button>
              </div>

              <div className="modal-body">
                <table className="table table-bordered table-striped mb-0">
                  <tbody>
                    {Object.entries(viewItem.data || {}).map(([key, value]) => {
                      const labels = {
                        designation: "Designation",
                        agencyName: "Agency Name",
                        fromDate: "From Date",
                        toDate: "To Date",
                        pf: "PF Applicable",
                        pfNumber: "PF Number",
                        esi: "ESI Applicable",
                        esiNumber: "ESI Number",
                      };

                      if (value === "" || value == null || key === "verificationStatus") return null;

                      return (
                        <tr key={key}>
                          <th style={{ width: "35%" }}>
                            {labels[key] || key.replace(/([A-Z])/g, " $1")}
                          </th>
                          <td>{String(value)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm w-auto"
                  onClick={closeView}
                >
                  Close
                </button>
              </div> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Registration;
